import api from "../../Api/feathers-client";

// Call backend service to get all tasks
export const getContinueTeaching = async (loggedInUser, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-userlogs-continue-teaching").find({
        query: {
          verb: "continueTeaching",
          actor: loggedInUser,
          site_uuid: site_uuid,
          $sort: {
            created_at: -1,
          },
          $limit: -1,
        },
      });

      resolve({
        status: 200,
        message: "All Continue Teaching",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
